import { compose, withState, lifecycle } from 'recompose';
import config from '../../../config';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import { showErrorMsg } from '../../Common/ErrorMsg';
import camelize from 'camelize';

const listTypeApi = () => $.get(`${config.localeApi}/reminder-types`)
  .fail((resp) => {
    const {
      errors = '',
    } = resp.responseJSON;
    showErrorMsg(errors);
  });


const withReminderListData = compose(
  withState('reminderTypes', 'setReminderTypes', []),
  withSpinnerOnAjax('getRemiderTypes', listTypeApi),
  lifecycle({
    componentDidUpdate() {
      this.shouldCallApi = window.location.pathname.includes('remind-me');
      if(this.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        this.props.getRemiderTypes()
        .done(response => {
            this.props.setReminderTypes(camelize(response.data));
        })
      }
    }
  }),
);

export default withReminderListData;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/withReminderLisTypes.js